import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerBondHandler } from '../../providers/consumer-bond-handler';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';

@Component({
  selector: 'page-consumer-pins',
  templateUrl: 'consumer-pins.html',
})
export class ConsumerPinsPage {
	hasBusinesses: any = true;

	businesses: any = [];
	
	isRefreshing: boolean = false;
	isLoading: boolean = false;

	constructor(
		public navCtrl: NavController, 
		public bondHandler: ConsumerBondHandler,
		public consumerBusinessHandlerProvider: ConsumerBusinessHandlerProvider,
		public consumerRewardHandlerProvider: ConsumerRewardHandlerProvider,
		public navParams: NavParams) {
	}

	doRefresh(refresher) {
		this.isRefreshing = true;			

		this.loadBusinesses(()=>{
			this.isRefreshing = false;
			refresher.complete();
		});
	}  		

	ionViewDidLoad() {
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.loadBusinesses(()=>{
			this.isLoading = false;
		});
	}	

	loadBusinesses(cb){
		this.consumerBusinessHandlerProvider.getPinnedBusinesses((businesses)=>{
			this.hasBusinesses = (businesses.length == 0) ? false : true;

			this.businesses = businesses;

			if(cb)
				cb();
		});
	}		
}



// WEBPACK FOOTER //
// ./src/pages/consumer-pins/consumer-pins.ts